import __request__ from "routing/request";
export function listPriorities(sort = "priority", page = 1, per_page = 15, query, direction = "asc", requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.securityapp/investigations/priorities", null, { "page": page, "per_page": per_page, "query": query, "sort": sort, "direction": direction }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function create(priority, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.securityapp/investigations/priorities", priority, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getAll(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.securityapp/investigations/priorities/all", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function removeDefault(requestOptions) {
  return __request__("DELETE", "/plugins/org.graylog.plugins.securityapp/investigations/priorities/default", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function updatePriorities(priorities, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.securityapp/investigations/priorities/reprioritize", priorities, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function update(id, priority, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.securityapp/investigations/priorities/${id}`, priority, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function remove(id, requestOptions) {
  return __request__("DELETE", `/plugins/org.graylog.plugins.securityapp/investigations/priorities/${id}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function setDefault(id, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.securityapp/investigations/priorities/${id}/default`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
